module.exports = __webpack_public_path__ + "static/media/unified.efb40b78.svg";